import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import Emco_Region_Table_Row from "../../../components/Settings/Emco_Region_Table_Row/Emco_Region_Table_Row";
import "./Regions.scss";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";

export class Regions extends Component {
	state = {
		emco_regions_table_rows: [], // This contains the list of emco_regions_table_row component for displaying it to the user. This is only used in the front end. We modify this if we want to change what we are displaying to the user in this page. So, if we remove a value then we would modify this or add a new table row.
		removed_emco_regions_ID_list: [], // This is the list of removed regions. We use this in the backend
		list_of_regions: [] // This is an array of objects. We use this for the backend to update the changes the user made in the frontend
	};

	remove_region = async (region_table_row_index, emco_region_ID) => {
		console.log("index ", region_table_row_index);
		console.log("emco region id ", emco_region_ID)
		// -- Modify the list of emco_region_table_rows component you are displaying and remove the one the user removed. --
		let updated_list_of_emco_regions_table_rows = [...this.state.emco_regions_table_rows];
		await updated_list_of_emco_regions_table_rows.splice(region_table_row_index, 1); // -- !!!!!!THIS IS THE ONLY THING THAT IS NOT WORKING. COME BACK TO THIS LATER!!!!!!! -- I need help on this. I'm having that same problem we had in the project setup page when you remove a room.

		// -- Modify the list of emco_regions_object for the backend. So, the backend knows to not create a new record in the database table because it doesn't exist anymore. It will make more sense if you read the backend code. --
		let updated_list_of_regions_for_the_backend = [...this.state.list_of_regions]
		await updated_list_of_regions_for_the_backend.splice(region_table_row_index, 1)

		await this.setState({
			emco_regions_table_rows: updated_list_of_emco_regions_table_rows,
			removed_emco_regions_ID_list: [
				...this.state.removed_emco_regions_ID_list,
				emco_region_ID
			],
			list_of_regions: updated_list_of_regions_for_the_backend
		});
	};

	// NOTE: This function is for all the input fields in the regions table. This makes the code managable and reusable. It keeps the code organized and clean. This makes the code optimal.
	modify_region = async (
		region_index_for_list_of_regions_state_array,
		modified_region_object,
		modified_region_property_name
	) => {
		// I don't completely understand how it falls short in one index but it works


		// -- This if statement is checking if the object already exist in the array by seeing if the length is less than or equal to the index we recieved as a paramter --
		if (this.state.list_of_regions.length - 1 < region_index_for_list_of_regions_state_array) {
			// -- add the object because it does not exist --
			let updated_list_of_regions = [...this.state.list_of_regions];
			updated_list_of_regions.push(modified_region_object);

			await this.setState({ list_of_regions: updated_list_of_regions });
			console.log("created a new one ", this.state.list_of_regions);
			console.log("here is the idnex ", region_index_for_list_of_regions_state_array)
		} else {
			// -- modify the existing object property name that was passed as a parameter to this function --
			let updated_list_of_regions = [...this.state.list_of_regions]; // This makes it immutable. Which is good for some reason and was always told to do this from the tutorials I watched.

			// ** DEBUGGING **
			console.log("target", updated_list_of_regions[region_index_for_list_of_regions_state_array])
			console.log("target property value", updated_list_of_regions[region_index_for_list_of_regions_state_array][
				modified_region_property_name
			])
			console.log("user input value in a object property ", modified_region_object[modified_region_property_name])
			console.log("region index ", region_index_for_list_of_regions_state_array)

			updated_list_of_regions[region_index_for_list_of_regions_state_array][
				modified_region_property_name
			] = modified_region_object[modified_region_property_name];

			this.setState({ list_of_regions: updated_list_of_regions });
			console.log("updated list of regions value ", this.state.list_of_regions);
		}
	};

	componentDidMount = async () => {
		let get_all_emco_regions_API_URL = this.props.APIUrl + "/regions";
		let get_all_emco_regions_API_response = await Axios.get(get_all_emco_regions_API_URL);

		console.log(
			"here is the api response for getting all the emco regions ",
			get_all_emco_regions_API_response
		);

		let all_emco_regions = get_all_emco_regions_API_response.data.all_emco_regions;

		let emco_regions_table_rows = await all_emco_regions.map((emco_region, index) => (
			<Emco_Region_Table_Row
				emco_region_ID={emco_region.id} // We will need this for adding to the list of removed regions. We use this to let the backend know which region to delete.
				emco_region_table_row_index={index} // We will use this when trying to remove a region.
				location_title={emco_region.location_title} // We need to pass this when we call the transfer_project() function in the table row component
				id_prod={emco_region.id_prod}
				id_dev_isTrain={emco_region["id_dev-istrain"]}
				id_dev={emco_region.id_dev}
				modify_region={this.modify_region}
				remove_region={this.remove_region}
			/>
		));

		this.setState({ emco_regions_table_rows, list_of_regions: all_emco_regions });
	};

	add_new_region = async () => {
		// -- Create the new table row to add to the list of table row components state that we are using to display to the user --
		// Note: We are not creating a new emco region object and adding it to the list of existing emco region object that will be used in the backend to update the existing regions if they were modified. That will happen when the user enters value on the input fields. That event handler function will handle creating a new object for this COMPLETELY newly created region. The event handler function name is modify_region and it's in this component. But it's being called in the emco_region_table_row child component.
		let new_emco_region_table_row = (
			<Emco_Region_Table_Row
				modify_region={this.modify_region}
				remove_region={this.remove_region}
				emco_region_table_row_index={this.state.emco_regions_table_rows.length}
				emco_region_ID={false}
				location_title={""} // We need to pass this when we call the transfer_project() function in the table row component
				id_prod={""}
				id_dev_isTrain={""}
				id_dev={""}
			/>
		);
		let updated_emco_regions_table_rows = [...this.state.emco_regions_table_rows];
		updated_emco_regions_table_rows.push(new_emco_region_table_row);

		this.setState({ emco_regions_table_rows: updated_emco_regions_table_rows });
	};

	save_changes = async () => {
		let save_emco_regions_changes_API_URL = this.props.APIUrl + "/regions/save-changes";
		let data = {
			removed_emco_regions_ID_list: this.state.removed_emco_regions_ID_list,
			added_emco_regions_object_list: this.state.added_emco_regions_object_list,
			list_of_emco_regions_objects: this.state.list_of_regions
		};

		let save_emco_regions_changes_API_response = await Axios.post(
			save_emco_regions_changes_API_URL,
			data
		);

		console.log(
			"api response for saving emco regions changes",
			save_emco_regions_changes_API_response
		);
	};

	render() {
		let main = (
			<>
				<div class="card user-profile-card">
					<table class="table search-results-table">
						<thead id="search-projects-table-header">
							<tr>
								<th scope="col">Region</th>
								<th scope="col">Production</th>
								<th scope="col">isTrain</th>
								<th scope="col">is2</th>
								<th scope="col" />
							</tr>
						</thead>
						<tbody>
							{this.state.emco_regions_table_rows.map(
								emco_region_table_row => emco_region_table_row
							)}
						</tbody>
					</table>
					<button
						style={{ height: "3em", margin: "1em auto auto auto", display: "block" }}
						onClick={this.add_new_region}
						type="button"
						class="btn btn-primary"
					>
						Add New Region
					</button>
					<button
						style={{ height: "3em", margin: "1.5em" }}
						onClick={() => this.save_changes()}
						type="button"
						class="btn btn-primary"
					>
						Save Changes
					</button>
				</div>
			</>
		);

		return (
			<SettingsWrapper header="Regions" main={main} classes="regions-settings-page"/>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Regions);
